/** Password Expired Service Error. */
export class ProfilePasswordExpiredError extends Error {
  /**
   * Create a password expired service error.
   * @param {number} userId - The id of the user with the password expired.
   */
  constructor (userId) {
    super()
    this.userId = userId
  }
}
